import React from 'react';
import TableAssignmentsChart from '../components/TableAssignmentsChart';

const TableAssignmentsApp = (props) => <TableAssignmentsChart {...props} />;

export default TableAssignmentsApp;
